import React from 'react';
import { ScadaShowCard } from './ScadaShowCard';

export const ScadaShowPage = ({ id }) => {
  return (
    <ScadaShowCard id={id} />
  );
};